import { render } from "./SummaryTab.vue?vue&type=template&id=5f691a2c"
import script from "./SummaryTab.vue?vue&type=script&lang=js"
export * from "./SummaryTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__